export const sx = {
    root: {
        padding:'10px 0'
    }

}